import { useCallback } from "react";

import { makeRequest } from "../lib/request";
import { useGalleryStore } from "../store/galleryStore";
import { useUserStore } from "../store/userStore";

export function useGallery() {
  const user = useUserStore((state) => state.user);

  const setPost = useGalleryStore((state) => state.setPost);
  const setPostLoading = useGalleryStore((state) => state.setPostLoading);
  const setPostError = useGalleryStore((state) => state.setPostError);
  const setPosts = useGalleryStore((state) => state.setPosts);
  const setPostsLoading = useGalleryStore((state) => state.setPostsLoading);
  const setPostsError = useGalleryStore((state) => state.setPostsError);

  const retrieveAllPosts = useCallback(async (count: number): Promise<void> => {
    try {
      setPostsLoading(true);

      const { posts } = await makeRequest(`public/gallery/list?take=${count}`, {
        cache: "no-store",
      });

      setPosts(posts);
      setPostsLoading(false);
    } catch (error) {
      setPostsError("Error fetching posts.");
      setPostsLoading(false);
    }
  }, []);

  const retrievePost = useCallback(
    async (exchangeSafe?: string, titleSafe?: string): Promise<void> => {
      try {
        setPostLoading(true);

        let url: string | null = null;

        if (user) {
          url = `private/gallery/post?exchangeSafe=${exchangeSafe}&titleSafe=${titleSafe}`;
        } else {
          url = `public/gallery/post?exchangeSafe=${exchangeSafe}&titleSafe=${titleSafe}`;
        }

        const post = await makeRequest(
          `public/gallery/post?exchangeSafe=${exchangeSafe}&titleSafe=${titleSafe}`,
          {
            cache: "no-store",
          }
        );

        if (post.status) {
          setPost(post.post);
          setPostError(null);
          setPostLoading(false);
        } else {
          setPost(null);
          setPostError("Error fetching post.");
          setPostLoading(false);
        }
      } catch (error) {
        setPostError("Error fetching post.");
        setPost(null);
        setPostLoading(false);
      }
    },
    [user]
  );

  return {
    retrievePost,
    retrieveAllPosts,
  };
}
